import angular from 'angular';
import uiRouter from 'angular-ui-router';
import StoreRegisterComponent from './register.component';

const storeRegisterModule = angular.module('tinaba.components.store.register', [
  uiRouter,
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('store.register', {
      url: '/register',
      template: '<store-register></store-register>',
    });
})
.component('storeRegister', StoreRegisterComponent);


export default storeRegisterModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/register/register.js
 **/